'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _errorMessages = require('./errorMessages');

var _errorMessages2 = _interopRequireDefault(_errorMessages);

var _formatting = require('./formatting');

var _formatting2 = _interopRequireDefault(_formatting);

var _validation = require('./validation');

var _validation2 = _interopRequireDefault(_validation);

var _alphanum = require('./alphanum');

var _alphanum2 = _interopRequireDefault(_alphanum);

var _initials = require('./initials');

var _initials2 = _interopRequireDefault(_initials);

var _integer = require('./integer');

var _integer2 = _interopRequireDefault(_integer);

var _lastname = require('./lastname');

var _lastname2 = _interopRequireDefault(_lastname);

var _licenseplate = require('./licenseplate');

var _licenseplate2 = _interopRequireDefault(_licenseplate);

var _phonenumber = require('./phonenumber');

var _phonenumber2 = _interopRequireDefault(_phonenumber);

var _email = require('./email');

var _email2 = _interopRequireDefault(_email);

var _zipcode = require('./zipcode');

var _zipcode2 = _interopRequireDefault(_zipcode);

var _werkgeverselectie = require('./werkgeverselectie');

var _werkgeverselectie2 = _interopRequireDefault(_werkgeverselectie);

var _cbForm = require('./cb-form.directive');

var _cbForm2 = _interopRequireDefault(_cbForm);

var _cbSubmit = require('./cb-submit.directive');

var _cbSubmit2 = _interopRequireDefault(_cbSubmit);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _module = angular.module('cb.core.forms', [_errorMessages2.default.name, _formatting2.default.name, _validation2.default.name, _alphanum2.default.name, _initials2.default.name, _integer2.default.name, _lastname2.default.name, _licenseplate2.default.name, _phonenumber2.default.name, _email2.default.name, _zipcode2.default.name, _werkgeverselectie2.default.name, _cbForm2.default.name, _cbSubmit2.default.name]).run(['errorMessagesService', function init(errorMessagesService) {
    errorMessagesService.templateErrorMessages();
}]);

exports.default = _module;


//////////////////
// WEBPACK FOOTER
// ./src/lib/core/forms/index.js
// module id = 786
// module chunks = 0